"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const cn_1 = require("src/misc/cn");
const JupButton = react_1.default.forwardRef(({ onClick, disabled, children, className = '', size = 'md' }, ref) => {
    const contentClass = (() => {
        if (size === 'sm') {
            return 'px-4 py-2.5 text-xs';
        }
        if (size === 'md') {
            return 'px-4 py-3 text-sm font-semibold';
        }
        if (size === 'lg') {
            return 'p-5 text-md font-semibold';
        }
    })();
    return ((0, jsx_runtime_1.jsx)("button", { type: 'button', ref: ref, className: (0, cn_1.cn)("rounded-xl", {
            relative: true,
            'opacity-50 cursor-not-allowed': disabled,
            [className]: true,
        }), disabled: disabled, onClick: onClick, children: (0, jsx_runtime_1.jsx)("div", { className: `${contentClass} h-full w-full leading-none`, children: children }) }));
});
JupButton.displayName = 'JupButton';
exports.default = JupButton;
